import { Box, CircularProgress, Drawer, useMediaQuery, useTheme } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import Navigator from './Navigator';
import { useEffect, useRef, useState } from 'react';
import SolutionDetail from './SolutionDetail';
import { useData } from '../../hooks/useData';
import DrawerHeaderBox from '../../components/DrawerHeaderBox';
import { post } from '../../api';

import { selectNavigatorData, selectNavigatorStatus, selectNavigatorError, initializeAsync, updateSolutionAsync, initializeWithoutLoadAsync } from './navigatorSlice';
import { skeleton } from './skeleton';
import { useLocation, useNavigate } from 'react-router-dom';
import BusinessNavigatorLanding from './BusinessNavigatorLanding';

function BusinessNavigatorPage() {
    const data = useSelector(selectNavigatorData);
    const status = useSelector(selectNavigatorStatus);
    const error = useSelector(selectNavigatorError);
    const dispatch = useDispatch();
    const { navigationList } = useData();
    const [selectNavigationItem, setSelectNavigationItem] = useState({});
    const [solutionCategories, setSolutionCategories] = useState([]);

    const [loading, setLoading] = useState(false);
    const theme = useTheme();
    const isMobileView = useMediaQuery(theme.breakpoints.down('md'));
    const location = useLocation();
    const navigate = useNavigate();

    const searchParams = new URLSearchParams(location.search);

    const selectedItemDetails = {
        selectedNavId: searchParams.get('selectedNavId'),
        selectedListItemId: searchParams.get('selectedListItemId'),
    };

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    useEffect(() => {
        if (status === 'idle') {
            dispatch(initializeAsync({}));
        }
    }, [status, dispatch]);

    useEffect(() => {
        if (status !== 'idle') {
            dispatch(initializeWithoutLoadAsync({}));
        }
    }, [location.pathname]);

    const drawerClose = () => setIsDrawerOpen(false);
    const drawerOpen = () => setIsDrawerOpen(true);

    const handleBack = () => {
        setSelectNavigationItem({});
        drawerClose();

        const newParams = new URLSearchParams(location.search);
        newParams.delete('selectedNavId');
        newParams.delete('selectedListItemId');
        navigate(`${location.pathname}?${newParams.toString()}`);
    };

    const getStartedBtnHandler = () => {
        setSelectNavigationItem(data?.records[1].list[1]);
    };

    const handleSolutionUpdate = (solution) => {
        if (selectNavigationItem.id === solution.id) {
            setSelectNavigationItem({ ...solution });
            dispatch(updateSolutionAsync(solution));
        }
    };

    const selectedNavItem = data?.records?.find((cItem) => cItem.id === selectedItemDetails?.selectedNavId);

    useEffect(() => {
        const selectedListItem = selectedNavItem?.solutions.find((cItem) => {
            return cItem.id === selectedItemDetails.selectedListItemId;
        });

        setSelectNavigationItem(selectedListItem || {});
        selectedListItem ? drawerOpen() : drawerClose(); //open drawer only if selected item present
    }, [selectedItemDetails.selectedListItemId, selectedNavItem]);

    const RightPaperBoxUI = () => {
        return (
            <>
                {selectNavigationItem?.id && (
                    <SolutionDetail solution={selectNavigationItem} updateSolution={handleSolutionUpdate} setLoading={setLoading} loading={loading} />
                )}
                {selectNavigationItem.id === undefined && <BusinessNavigatorLanding getStartedBtnHandler={getStartedBtnHandler} />}
            </>
        );
    };
    return status === 'initialLoading' ? (
        skeleton
    ) : (
        <Box display={'flex'} height={'100%'}>
            <Navigator
                navigationList={data?.records}
                selectNavigationItem={selectNavigationItem}
                setSelectNavigationItem={setSelectNavigationItem}
                drawerOpen={drawerOpen}
                selectedItemDetails={selectedItemDetails}
            />

            {isMobileView ? (
                <Drawer
                    open={isDrawerOpen}
                    onClose={drawerClose}
                    anchor="right"
                    sx={{
                        '& .MuiPaper-root.MuiDrawer-paper': {
                            width: '100%',
                        },
                    }}
                >
                    <DrawerHeaderBox handleBack={handleBack} hideBackBtn={loading} heading={selectedNavItem?.name} para={selectedNavItem?.para} />

                    {RightPaperBoxUI()}
                </Drawer>
            ) : (
                RightPaperBoxUI()
            )}
        </Box>
    );
}

export default BusinessNavigatorPage;
